<template>
  <div class="flex-start nav-panel common-nav-panel">
    <div class="nav-drop-down-panel">
      <div class="flex-center nav-drop-down-icon" @click="showPopup">
        <img src="@/images/com/black_nav_icon.png" alt="">
      </div>
     <van-popup v-model="show" position="left" class="nav-drop-down-content" :style="{ height: '100%' }" >
       <div class="delete-nav-icon-panel flex-start" @click="closeNav"><img src="@/images/com/delete_nav_icon.png" alt=""></div>
       <ul>
         <li v-for="(item,index) in navData" :key="index"  @click='routerPage(item.path)' class="flex-start">
         {{item.name}}
         </li>
       </ul>
     </van-popup>
    </div>
    <div class="flex-center nav-logo">
      <img src="@/images/com/black_logo1.png" alt="">
    </div>
  </div>
</template>

<script>
  import "@/css/nav.scss"
  export default {
    name: 'leftNav',
    data() {
      return {
        showNav: false,
         show: false,
        active: 0,
        navData: [
          {
            name: '首页',
            path: '/'
          },
          {
            name: '关于我们',
            path: 'aboutUs'
          },
          {
            name: '核心业务',
            path: 'coreBusiness'
          },
          {
            name: '人才文化',
            path: 'talentCulture'
          },
          {
              name: '新闻动态',
              path: 'news'
            },
          {
            name: '联系我们',
            path: 'contactUs'
          }

        ]
      }
    },
    methods: {
        showPopup() {
            this.show = true;
          },

      closeNav(){
        this.show = false;
      },
     routerPage(path){
       this.show = false;
       this.$router.push({
         path:path
       })
     }
    },

  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/nav/leftNav.vue